import React from 'react';

const LinkToolsHeader: React.FC = () => {
  return (
    <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-2xl font-bold text-gray-900">Link Tools Hub</h1>
            <span className="rounded-full bg-yellow-100 px-2 py-0.5 text-xs font-semibold text-yellow-800 border border-yellow-200">
              Beta
            </span>
          </div>
          <p className="mt-1 text-sm text-gray-600">
            Create short links, generate QR codes, and track analytics — all in one place
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
              <span className="text-lg">🔗</span>
            </div>
            <div>
              <div className="text-xs text-gray-500">URL Shortener</div>
              <div className="text-sm font-semibold text-gray-900">Track & Share</div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-purple-100">
              <span className="text-lg">📱</span>
            </div>
            <div>
              <div className="text-xs text-gray-500">QR Codes</div>
              <div className="text-sm font-semibold text-gray-900">Customizable</div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-100">
              <span className="text-lg">📊</span>
            </div>
            <div>
              <div className="text-xs text-gray-500">Analytics</div>
              <div className="text-sm font-semibold text-gray-900">Real-time</div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 rounded-lg bg-yellow-50 border border-yellow-200 p-3">
        <p className="text-xs text-yellow-900">
          <strong>Beta Feature:</strong> Limited to 10 links per month. Analytics and limits may change.
        </p>
      </div>
    </div>
  );
};

export default LinkToolsHeader;
